module.exports = __webpack_public_path__ + "img/b0dfde98-bf7e-44eb-a3d9-526813815f4e.2192dd9c.svg";